<template>
    <div class="vm-rank-top flex-box flex-align-items-center" :class="[browser_size]">
        <div class="item text-center" v-for="(user, i) in user_list" :key="i">
            <avatar class="wh40" :user="user" is_only_avatar="1"></avatar>
            <router-link
                :to="$userlink(user)"
                class="fs12 text-overflow-1 mt8 black-8 gl-hover-text-purple"
            >{{ user.name }}</router-link>
            <img class="icon" :src="`${GL.PIC_HOST}/static/img/rank-${i + 1}.png`" alt="">
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    user_id: {
      type: String,
      default() {
        return "";
      }
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["browser_size"]),
    user_list() {
      return this.list.slice(0, 3);
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="stylus" scoped>
.vm-rank-top {
    &.middle, &.large {
        justify-content: space-between;

        .item {
            width: 100px;
        }
    }

    .item {
        position: relative;
        width: 63px;
        margin-right: 16px;

        &:last-child {
            margin-right: 0;
        }
    }

    .vm-avatar {
        margin: 0 auto;
    }

    .icon {
        width: 24px;
        position: absolute;
        top: -18px;
        left: 50%;
        transform: translateX(4px);
    }
}
</style>
